import { ReactComponent as WhiteGloveSvg } from "@/assets/svg/hand-with-cover.svg";
import { ReactComponent as BannerSvg } from "@/assets/illustrations/home-banner.svg";
import { Button, Text } from "@/components";

export const Banner = () => {
  return (
    <div className="relative container mx-auto overflow-hidden">
      <BannerSvg className="hidden md:block md:w-full 2xl:min-w-[1384px] h-auto" />

      <img
        className="mt-[300px] md:-mt-[80px] lg:-mt-[200px] xl:-mt-[320px] w-full h-auto"
        src="/images/home-banner--laptop.png"
        alt="T12 Cap Table"
      />

      <div className="absolute left-4 right-4 md:left-0 md:right-0 top-0 flex flex-col items-center py-10 gap-2.5 overflow-hidden">
        <div className="flex items-center justify-center gap-x-2.5 text-xl text-secondary uppercase font-medium 2xl:text-3xl">
          <WhiteGloveSvg className="2xl:w-14 2xl:h-14" />
          <span>White Glove</span>
        </div>

        <Text.Heading className="max-w-[900px] text-center text-white 2xl:text-[76px] 2xl:max-w-[70%]">
          The Complete Done-For-You Equity Management Service
        </Text.Heading>

        <div className="text-lg md:text-2xl max-w-[73w] my-2.5">
          We do everything but write the check
        </div>

        <Button
          className="w-full py-4 max-w-[600px] mt-4 2xl:py-[30px] 2xl:text-3xl 2xl:max-w-screen-md"
          href="/pricing"
        >
          Pricing & Plans
        </Button>
      </div>
    </div>
  );
};
